import { render, staticRenderFns } from "./LaBottomLayout.vue?vue&type=template&id=24502438&scoped=true&"
import script from "./LaBottomLayout.vue?vue&type=script&lang=js&"
export * from "./LaBottomLayout.vue?vue&type=script&lang=js&"
import style0 from "./LaBottomLayout.vue?vue&type=style&index=0&id=24502438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24502438",
  null
  
)

export default component.exports